import {
  getBmi,
} from "../../../common/js/helpers"

export default () => ({
  duration: 2000,
  startTime: 0,

  currentBmi: 0,
  currentPos: 0,
  targetBmi: 0,
  targetPos: 0,

  // Dynamic values we'll change over time
  animatedBmi: 0,
  animatedPos: 0,

  // We've got dynamic tooltip also there
  tooltipStyle: {},

  init() {
    this.store = Alpine.store("data")

    this.currentBmi = +this.getBmi()
    this.currentPos = this.getPointPosition(this.currentBmi)

    this.targetBmi = +this.getTargetBmi()
    this.targetPos = this.getPointPosition(this.targetBmi)

    this.animateBmi()
  },

  getBmi() {
    const isMetric = this.store.isMetric()
    return getBmi(this.store.values, isMetric).toFixed(2)
  },

  getTargetBmi() {
    const { heightCm, heightFt, heightIn, targetWeightKg, targetWeightLbs } = this.store.values
    const values = { heightCm, heightFt, heightIn, weightKg: targetWeightKg, weightLbs: targetWeightLbs }
    const isMetric = this.store.isMetric()
    return getBmi(values, isMetric).toFixed(2)
  },

  getPointPosition(bmi) {
    const scaleMin = 15
    const scaleMax = 35
    if (bmi <= scaleMin) return 0
    if (bmi >= scaleMax) return 100
    return ((bmi - scaleMin) * 100) / (scaleMax - scaleMin)
  },

  animateBmi() {
    this.startTime = performance.now()
    const startBmi = this.currentBmi
    const startPos = this.currentPos

    const step = (time) => {
      const elapsed = time - this.startTime
      const progress = Math.min(elapsed / this.duration, 1)

      this.animatedBmi = (
        startBmi + (this.targetBmi - startBmi) * progress
      ).toFixed(1)
      this.animatedPos =
        startPos + (this.targetPos - startPos) * progress

      this.renderTooltip()

      if (progress < 1) requestAnimationFrame(step)
    }

    requestAnimationFrame(step)
  },

  renderTooltip() {
    const PADDING_COMPENSATION = -12
    const container = this.$refs.widgetBmiAxis
    const tooltip = this.$refs.tooltip

    if (!container || !tooltip) return {}

    const containerWidth = container.offsetWidth
    const tooltipWidth = tooltip.offsetWidth
    const pointX = (this.animatedPos / 100) * containerWidth

    // Start by centering tooltip
    let left = pointX - tooltipWidth / 2

    // Guard the left edge from overflow
    if (left < PADDING_COMPENSATION) left = PADDING_COMPENSATION

    // Guard the right edge from overflow
    if (left + tooltipWidth > containerWidth) {
      const leftCompensated = containerWidth - tooltipWidth
      left = (leftCompensated < PADDING_COMPENSATION) ? PADDING_COMPENSATION : leftCompensated
    }

    this.tooltipStyle = { left: `${left}px` }

  }
})
